import React from 'react';

// Recapiti spezzati in frammenti e riassemblati a runtime:
// limitano la raccolta automatica da parte dei bot (anti-scraping)
// pur restando perfettamente visibili e cliccabili per i visitatori.
const P1 = ['+39', '339', '355', '8712'];
const EM = ['eventi', 'gustavo28', 'it'];

export const PhoneLink = ({ className = '', testid, icon = null }) => {
  const display = `${P1[0]} ${P1.slice(1).join(' ')}`;
  return (
    <a href={`tel:${P1.join('')}`} data-testid={testid} className={className}>
      {icon} {display}
    </a>
  );
};

export const EmailLink = ({ className = '', testid, icon = null }) => {
  const display = `${EM[0]}@${EM[1]}.${EM[2]}`;
  return (
    <a href={`mailto:${display}`} data-testid={testid} className={className}>
      {icon} {display}
    </a>
  );
};
